import React from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { Typography } from '../../../widgets/Typography';

type Props = {
  onRatingSelect: (value: number) => void;
};

const ratingValues = Array.from({ length: 11 }, (_, index) => index);
const scoreColors = [
  '#D92D20',
  '#ED4124',
  '#F05A28',
  '#F87926',
  '#F2983E',
  '#FDB022',
  '#ECC825',
  '#E8D959',
  '#D8D95E',
  '#BBCA52',
  '#8AC015',
];

export default function NpsRatingStep({ onRatingSelect }: Props) {
  const { t } = useTranslation();

  const [hoveredIndex, setHoveredIndex] = React.useState<number | null>(null);

  return (
    <div className="w-full max-w-[696px]">
      <Typography
        variant="body-xl"
        weight="bold"
        className="mb-4"
        align="center"
      >
        {t('NPS_HEADING')}
      </Typography>
      <div className="text-black-700 m-auto mx-1 mb-2 flex max-w-[300px] justify-between text-sm md:max-w-none">
        <span>0: {t('NPS_RATING_ZERO')}</span>
        <span>10: {t('NPS_RATING_TEN')}</span>
      </div>

      <div
        className="m-auto flex max-w-[300px] flex-wrap justify-center md:max-w-none md:flex-nowrap"
        onMouseLeave={() => setHoveredIndex(null)}
      >
        {ratingValues.map((value, index) => {
          return (
            <div
              key={value}
              className="group relative flex items-center px-1 md:px-3"
              onMouseEnter={() => setHoveredIndex(index)}
            >
              <button
                role="radio"
                className={twMerge(
                  'relative h-10 w-10 cursor-pointer rounded-full text-sm font-medium transition',
                )}
                style={{
                  backgroundColor:
                    hoveredIndex !== null && hoveredIndex >= index
                      ? scoreColors[index]
                      : '#E0E0E0',
                }}
                onClick={() => onRatingSelect(value)}
              >
                {value}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
